import React, { useEffect, useRef, useState } from "react";

export const Clip = ({children, top = 20}) => {

  const [ open, setOpen ] = useState(false);

  const divRef = useRef();
  const handleClose = () => {
    setOpen(!open)
  }
  
  useEffect(()=>{
    if(!open){
      divRef.current.style.left = `-${(divRef.current.offsetWidth - 12)}px`
    }else{
      divRef.current.style.left = `0px`
    }

  }, [open]);

  return (
    <div 
      ref={divRef}
      style={{...styleClip, top}}
    >
      <div style={{flex: 1}}>
        {children}
      </div>
      <div onClick={handleClose} 
        style={{
          width: 12, 
          backgroundColor: "#3699ff", 
          textAlign: "center", 
          height: 30, 
          cursor: "pointer", 
          borderBottomRightRadius: 10, 
          borderTopRightRadius: 10,
          display: "flex",
          alignItems: "center",
        }}
      >
        {open ? "<" : ">"}
      </div>
    </div>
  );

}

const styleClip = {
  backgroundColor: "transparent",
  position: "fixed",
  left: 0,
  right: 0,
  zIndex: 10,
  display: "flex",
  flexDirection: "row",
  width: "fit-content",
}